import { UrlConstants } from "../url.constants";
export class ApiOrganisationNotificationTemplateConstants {
    static URL = UrlConstants.API_V2 + "OrganisationNotificationTemplate";
}
